import { Center, Grid, GridItem, Button, Stack, Text, Box } from '@chakra-ui/react'
import React from 'react'
import { DialerStateType } from '../contact-center.store'
import { maskPhoneNumber } from '../contact-center.utils'
import { useDialerState, useDialedNumber, useKeyPadKeyPressed } from './dialer.hooks'
import { DialerBtnStyles, TextBtnLabelStyles, TextSubStyles } from './dialer.style'
import { KeyPadControls } from './KeyPadControls'

export enum DialerType {
  BeforeCall,
  AfterCall,
}

export interface KeyPadProps {
  type: DialerType
  connectCall?: (d: DialerStateType) => void
}

export const KeyPad: React.FC<KeyPadProps> = ({ type, connectCall }) => {
  const { number: currentNumber, setNumber: setCurrentNumber } = useDialedNumber()
  const { setKeyPressed, keyPressed } = useKeyPadKeyPressed()
  const { setDialerState, dialerState } = useDialerState()

  const updateNumber = (key: string) => {
    if (type === DialerType.BeforeCall) {
      if (currentNumber.match(/\d/g)?.length === 14) return
      setCurrentNumber(currentNumber + key)
    }
    if (type === DialerType.AfterCall) setKeyPressed(key)
  }

  return (
    <>
      <Box bg="#F6F6F6" height="75px" pos="relative" mb="20px">
        <Text
          color="gray.700"
          fontFamily="Poppins"
          fontSize="12px"
          fontWeight="500"
          pos="relative"
          top="12px"
          left="14px"
        >
          DIALER
        </Text>
        <Center>
          {currentNumber?.length <= 0 && (
            <Text color="rgba(0, 0, 0, 0.16)" fontSize="20px" fontWeight="500" fontFamily="Poppins" mt="3px">
              Dial Number
            </Text>
          )}
          {currentNumber?.length >= 1 && (
            <Text color="gray-700" fontSize="24px" fontWeight="500" fontFamily="Poppins" mt="3px">
              {maskPhoneNumber(currentNumber)} {keyPressed}
            </Text>
          )}
        </Center>
      </Box>
      <Grid templateColumns="repeat(3, 27%)" rowGap="15px" columnGap="20px" ml="20px !important">
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" onClick={() => updateNumber('1')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>1</Text>
              <Text {...TextSubStyles}></Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" onClick={() => updateNumber('2')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>2</Text>
              <Text {...TextSubStyles}>ABC</Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" onClick={() => updateNumber('3')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>3</Text>
              <Text {...TextSubStyles}>DEF</Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" onClick={() => updateNumber('4')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>4</Text>
              <Text {...TextSubStyles}>GHI</Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" onClick={() => updateNumber('5')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>5</Text>
              <Text {...TextSubStyles}>JKL</Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" onClick={() => updateNumber('6')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>6</Text>
              <Text {...TextSubStyles}>MNO</Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" onClick={() => updateNumber('7')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>7</Text>
              <Text {...TextSubStyles}>PQRS</Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" onClick={() => updateNumber('8')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>8</Text>
              <Text {...TextSubStyles}>TUV</Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" onClick={() => updateNumber('9')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>9</Text>
              <Text {...TextSubStyles}>WXYZ</Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" isDisabled={false} onClick={() => updateNumber('*')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>*</Text>
              <Text {...TextSubStyles}></Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" onClick={() => updateNumber('0')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>0</Text>
              <Text {...TextSubStyles}></Text>
            </Stack>
          </Button>
        </GridItem>
        <GridItem>
          <Button {...DialerBtnStyles} variant="outline" isDisabled={false} onClick={() => updateNumber('#')}>
            <Stack dir="column">
              <Text {...TextBtnLabelStyles}>#</Text>
              <Text {...TextSubStyles}></Text>
            </Stack>
          </Button>
        </GridItem>
      </Grid>

      {type === DialerType.BeforeCall && (
        <KeyPadControls
          setCurrentNumber={setCurrentNumber}
          currentNumber={currentNumber}
          setDialerState={setDialerState}
          connectCall={connectCall}
          dialerState={dialerState}
        />
      )}
    </>
  )
}



export default KeyPad
